import { ref, onMounted } from 'vue';

export function useTheme() {
  const theme = ref('light');

  const applyTheme = () => {
    if (theme.value === 'dark') {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  const initTheme = () => {
    const cachedTheme = localStorage.getItem('theme');
    if (cachedTheme) {
      theme.value = cachedTheme;
    } else if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      theme.value = 'dark';
    } else {
      theme.value = 'light';
    }
    applyTheme();
  };

  const toggleTheme = () => {
    theme.value = theme.value === 'light' ? 'dark' : 'light';
    applyTheme();
    localStorage.setItem('theme', theme.value);
  };

  onMounted(() => {
    initTheme();
  });

  return {
    theme,
    toggleTheme
  };
}

